import { defineStore } from 'pinia'

import { countsByTab } from 'src/services/settings_search/settings_search.js'

let nextId = 0

// Every settings row registers the text it renders, so search can work
// across tabs without each tab having to know about it.
export const useSettingsSearchStore = defineStore('settingsSearch', {
  state: () => ({
    query: '',
    entries: {},
  }),
  getters: {
    searching: (state) => state.query.trim().length > 0,
    counts: (state) => countsByTab(Object.values(state.entries), state.query),
    advancedCount: (state) =>
      Object.values(state.entries).filter((entry) => entry.expert).length,
  },
  actions: {
    setQuery(query) {
      this.query = query
    },
    register({ tab, text, expert = false }) {
      const id = `s${nextId++}`
      this.entries[id] = { tab, text, expert }
      return id
    },
    unregister(id) {
      delete this.entries[id]
    },
  },
})
